import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import TextFieldBase from '@/components/mui/Form/TextField/TextFieldBase';
import InputAdornment from '@mui/material/InputAdornment';

import SearchIcon from '@mui/icons-material/Search';

const AppBarSearchBase = React.forwardRef(({ value, onChange, slotProps = {}, ...rest }, ref) => {
  const intl = useIntl();
  const [currentValue, setCurrentValue] = useState(value);

  const onChangeInput = (e) => {
    const { target } = e;
    setCurrentValue(target.value);
  };

  useEffect(() => {
    onChange(currentValue);
  }, [currentValue, onChange]);

  useEffect(() => {
    if (value.length === 0) {
      setCurrentValue('');
    }
  }, [value]);

  return (
    <TextFieldBase
      ref={ref}
      size="small"
      placeholder={intl.formatMessage({ id: 'header.search.placeholder', defaultMessage: 'Search' })}
      value={currentValue}
      onChange={onChangeInput}
      autoFocus
      fullWidth
      slotProps={{
        ...slotProps,
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          ...(slotProps.input || {}),
        },
      }}
      sx={{ maxWidth: '40ch' }}
      {...rest}
    />
  );
});

export default AppBarSearchBase;
